import { useMemoDeepCompare } from '@gilbarbara/hooks';
import { SlotsToClasses } from '@heroui/react';

import useMergeClassNames from '~/hooks/useMergeClassNames';

interface FieldConfig<S extends string> {
  readonly labelPlacement: 'outside';
  readonly placeholder: ' ';
  readonly variant: 'bordered';
  readonly classNames: SlotsToClasses<S>;
}

export function useField<S extends string>(
  defaultClassNames: SlotsToClasses<S>,
  customClassNames?: SlotsToClasses<S>,
): FieldConfig<S> {
  const classNames = useMergeClassNames(defaultClassNames, customClassNames);

  return useMemoDeepCompare(
    (): FieldConfig<S> => ({
      labelPlacement: 'outside',
      placeholder: ' ',
      variant: 'bordered',
      classNames,
    }),
    [classNames],
  );
}
